import { combineReducers } from 'redux'
import misc from './misc'
import members from './members'

export default combineReducers({
  misc,
  members,
})
